const syncReducer = (state = false, action) => {
    switch (action.type) {
        case 'SYNC_COMPLETED':
            return true;
        case 'RESET_SYNC':
            return false;
        case 'SYNC_REQUESTED':
            return 'SYNC_REQUESTED';
        default:
            return state;
    }
};

export default syncReducer
